/*****
 * Created by Allan on 2023/04/25.
 * Contact 84880528@qq.com.
 * 使用该全局指令
 * *****/
import Vue from 'vue'
import onlyNumber from "./inputNumber/onlyNumber";
const install=Vue=>{
	Vue.directive('onlyNumber',onlyNumber)
}

if (window.Vue) {
	window['onlyNumber'] = onlyNumber
	Vue.use(install); // eslint-disable-line
}
onlyNumber.install = install
export default onlyNumber



// WEBPACK FOOTER //
// ./src/directive/index.js